import cs from '../../messages/dativeryCommon.cs.po';
import en from '../../messages/dativeryCommon.pot';
import {getLocale as getBasicLocale} from './basicLocales';

let allLocales = {
    /* list locales here */
    'cs': cs,
    'en': en,
};


let messages = allLocales[getBasicLocale()];
if (!messages) {
    messages = allLocales['en'];
}

export function getCommonMessages(lang) {
	if (lang && allLocales[lang]) {
		return allLocales[lang];
	}

    return messages;
}

export function getCommonMessagesForLocale(locale) {
    return allLocales[locale];
}
